import { Controller } from "@hotwired/stimulus";
import {
  LAUNCH_REQUIREMENTS_CHANGED_EVENT,
  LAUNCH_STATUS_EVENT,
} from "@/categories/admin/campaigns/memberships/components/shared";

// Bridges the server-rendered launch button and the React settings tab: a
// settings change reloads this frame, and the reloaded frame's freshly-computed
// status is relayed back to React, so launch logic stays server-side only.
export default class extends Controller {
  static values = { reloadUrl: String };

  connect() {
    this.reload = this.reload.bind(this);
    this.broadcastStatus = this.broadcastStatus.bind(this);
    document.addEventListener(LAUNCH_REQUIREMENTS_CHANGED_EVENT, this.reload);
    this.element.addEventListener("turbo:frame-load", this.broadcastStatus);
  }

  disconnect() {
    document.removeEventListener(LAUNCH_REQUIREMENTS_CHANGED_EVENT, this.reload);
    this.element.removeEventListener("turbo:frame-load", this.broadcastStatus);
  }

  reload() {
    if (this.reloadUrlValue) this.element.src = this.reloadUrlValue;
  }

  broadcastStatus() {
    const node = this.element.querySelector("[data-launch-status]");
    if (!node) return;

    try {
      const detail = JSON.parse(node.dataset.launchStatus);
      document.dispatchEvent(new CustomEvent(LAUNCH_STATUS_EVENT, { detail }));
    } catch {
      // Malformed payload: leave the tab's current state in place.
    }
  }
}
